var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{ bgRow: _vm.row.data.iAmHighlited },on:{"click":_vm.onclick}},_vm._l((_vm.visibleColumns),function(column){return _c('table-cell',{key:column.id,attrs:{"row":_vm.row,"column":column}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fcf8ab9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/table/components/TableRow.vue
// module id = null
// module chunks = 